<template>
  <div>
    <h2>Reference codes</h2>
    <table>
      <thead>
      <tr>
        <th>Reference Code</th>
        <th>Discount</th>
        <th>Remaining Uses</th>
        <th>Expiry Date</th>
        <th>Referral email</th>
        <th colspan="2">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="discount in discounts">
        <td>
          {{ discount.code }}
        </td>
        <td>
          {{ discount.value }}
        </td>
        <td>
          <span v-if="discount.limit <= -1">Unlimited</span>
          <span v-else>{{ discount.limit }}</span>
        </td>
        <td>
          <span v-if="discount.expiry == ''">Never</span>
          <span>{{ discount.expiry }}</span>
        </td>
        <td>
          {{ discount.email ? discount.email : 'None' }}
        </td>
        <td>
          <span @click="destroy(discount)" class="delete-button">Delete</span>
        </td>
        <td>
          <span @click="edit(discount)" class="edit-button">Edit</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Discounts",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      discounts: null,
    }
  },
  mounted() {
    this.getDiscounts();
  },
  methods: {
    getDiscounts() {
      this.discounts = [];
      this.$axios.post(`${this.base}/api/discounts/get.php`)
          .then((response) => {
            this.discounts = response.data;
          });
    },
    edit(discount) {
      this.$emit('edit', discount);
    },
    destroy(discount) {
      if (confirm(`Are you sure you want to delete this discount code?`)) {
        this.$axios.post(`${this.base}/api/discounts/delete.php`, this.$makeForm({discount_code: discount.code}))
            .then(() => {
              this.getDiscounts();
            })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 50%;
  border-collapse: collapse;
  border: {
    left: 1px solid #CCD0D4;
    right: 1px solid #CCD0D4;
    bottom: 1px solid #CCD0D4;
  }

  thead {
    th {
      border: {
        top: 1px solid #CCD0D4;
        bottom: 1px solid #CCD0D4;
      }
      font-weight: normal;
      color: #32373C;
      background-color: #FFF;
      padding: 0.5rem;
      text-align: left;
    }
  }

  td {
    padding: 0.5rem;
  }

  tr:nth-child(odd) {
    background-color: #F9F9F9;
  }

  tr:nth-child(even) {
    background-color: #FFF;
  }

}

.edit-button {
  cursor: pointer;

  &:hover {
    color: orange;
  }
}

.delete-button {
  cursor: pointer;

  &:hover {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Discounts.vue